import { render, staticRenderFns } from "./CampaingPromoDialog.vue?vue&type=template&id=536f0c41&"
import script from "./CampaingPromoDialog.vue?vue&type=script&lang=js&"
export * from "./CampaingPromoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports